import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import Localization from "../../localization";
import Button from "../../components/button";
import Modal from "../../components/modal";

class ModalCancel extends Component {
    _onClose = () => {
        this.props.onClose(null);
    };

    _onCancel = () => {
        this.props.onClose(this.props.data);
    };

    render() {
        const { visible, title, text, locale } = this.props;

        return (
            <Modal
                maxWidth="xl:max-w-md"
                visible={visible}
                closeWithOverlay
                onClose={this._onClose}
            >
                <div className="flex flex-col p-32 rounded text-center">
                    <p className="font-judge font-bold text-30 text-blue">
                        {title}
                    </p>
                    <p className="mt-30 text-23 font-bold">{text}</p>
                    <div className="flex justify-center items-center mt-40">
                        <Button
                            text={
                                Localization[locale].spaces_booking
                                    .cancel_confirm
                            }
                            onClick={this._onCancel}
                            textStyle={
                                "font-bold text-20 xl:text-23 hover-hover:group-hover:text-white"
                            }
                            style="w-150"
                        />
                        <Button
                            text={
                                Localization[locale].spaces_booking
                                    .cancel_reject
                            }
                            onClick={this._onClose}
                            textStyle={
                                "font-bold text-20 xl:text-23 hover-hover:group-hover:text-white"
                            }
                            style="w-150 ml-16"
                        />
                    </div>
                </div>
            </Modal>
        );
    }
}

const mapStateToProps = (state) => ({
    locale: state.app.locale,
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalCancel);
